import * as React from 'react';

import { PageTitle } from 'components/pages/pageTitle';
import * as PermissionsHelper from 'helpers/permissionsHelper';
import ClipTemplateMapperForm from 'components/clients/clip-template-mapper/form/clip-template-mapper-form';
import styles from './clip-template-mapper.module.scss';

export const ClientsClipTemplateMappingPage = () => {
  return (
    <div className={styles.clipTemplateMapperPage}>
      <PageTitle displayTitle="Clip template mapper" />
      {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.UpdateClipTemplateConfiguration) && (
        <ClipTemplateMapperForm />
      )}
    </div>
  );
};
